var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .297C5.373.297 0 5.67 0 12.297c0 5.3 3.438 9.8 8.207 11.387.599.111.793-.26.793-.577 0-.285-.01-1.04-.016-2.04-3.338.726-4.042-1.61-4.042-1.61-.546-1.387-1.333-1.757-1.333-1.757-1.09-.744.083-.729.083-.729 1.205.085 1.838 1.236 1.838 1.236 1.07 1.835 2.807 1.304 3.492.997.108-.774.419-1.305.762-1.605-2.665-.305-5.466-1.333-5.466-5.933 0-1.311.469-2.383 1.236-3.223-.124-.304-.536-1.527.117-3.176 0 0 1.008-.322 3.301 1.23.957-.267 1.982-.4 3.003-.404 1.02.005 2.045.137 3.004.404 2.292-1.552 3.297-1.23 3.297-1.23.655 1.649.243 2.872.12 3.176.77.84 1.233 1.912 1.233 3.223 0 4.61-2.804 5.625-5.475 5.921.43.372.815 1.102.815 2.222 0 1.604-.015 2.898-.015 3.292 0 .32.192.694.8.576C20.565 22.092 24 17.592 24 12.297 24 5.67 18.627.297 12 .297",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.38a193fc04017383d576c386d4deb597.svg";
export { ForwardRef as ReactComponent };